import React, { useState } from 'react';

import AuthContext from '../../../AuthContext';
import mtzApis from '../../../services';

const { paymentService } = mtzApis;

const PlanUpsell = () => {
    let [myPlan, setMyPlan] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const me = React.useContext(AuthContext);

    React.useEffect(() => {
        init();
    }, []);

    const init = async () => {
        // get my plan
        let plans = await paymentService.getMtzPlanSubscriptions();
        if (plans && plans.length > 0) {
            setMyPlan(plans[0]);
        }
    }

    const handleClose = () => setShowModal(false);
    const handleShow = (e) => {
        e.preventDefault();
        setShowModal(true);
    }

    if (myPlan && myPlan.ready && !myPlan.cancelled) {
        return <></>;
    }

    return (
        <div className="position-relative">
            <div className='border border-dark bg-white mtz-rounded-16 mtz-p-16'>
                <a
                    href="#"
                    onClick={handleShow}
                    style={{ textDecoration: "none" }}
                >
                    <b>Upgrade to Premium Now! <br /> Click here to see what you get</b>
                </a>
            </div>

            {showModal && (
                <React.Fragment>
                    <div className="modal-overlay" style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust transparency as needed
                        backdropFilter: "blur(5px)", // Apply blur effect
                        zIndex: 999, // Ensure it's above the modal
                    }} onClick={handleClose}></div>
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                        <div className="modal-dialog modal-dialog-scrollable modal-dialog modal-dialog-scrollable-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Upgrade to Premium Now</h5>
                                    <button type="button" className="close" onClick={handleClose} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="border p-3">
                                        <p className="font-weight-bold text-dark">For a Small marketing budget of $20/month, upgrade to the Business Essential Plan. And you will instantly have access to advanced marketing tools, including:</p>
                                        <ul>
                                            <li className="font-weight-bold text-danger">List any 10 keyword phrases of your choice to appear on top of the search results</li>
                                            <li className="font-weight-bold text-danger">Ability to create and manage your own Networking groups</li>
                                            <li className="font-weight-bold text-danger">Create RFQ alerts for automatic leads notification</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                        Maybe Later
                                    </button>
                                    <a type="button" href="/pricing" className="btn btn-primary">
                                        See Pricing Plans
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
}

export default PlanUpsell;
